export const ITEM_DEFS = {
  '1': { id: '1', name: 'Grass Block', kind: 'block', color: '#5cad58', icon: 'G', stack: 64, placeBlockId: 1 },
  '2': { id: '2', name: 'Dirt', kind: 'block', color: '#8c5d31', icon: 'D', stack: 64, placeBlockId: 2 },
  '3': { id: '3', name: 'Log', kind: 'block', color: '#6a4525', icon: 'L', stack: 64, placeBlockId: 3 },
  '4': { id: '4', name: 'Leaves', kind: 'block', color: '#2f8f33', icon: 'V', stack: 64, placeBlockId: 4 },
  '5': { id: '5', name: 'Stone', kind: 'block', color: '#7f7f7f', icon: 'S', stack: 64, placeBlockId: 5 },
  '6': { id: '6', name: 'Planks', kind: 'block', color: '#cf9d62', icon: 'P', stack: 64, placeBlockId: 6 },
  '78': { id: '78', name: 'Camphor Log', kind: 'block', color: '#7d5c38', icon: 'CL', stack: 64, placeBlockId: 78 },
  '79': { id: '79', name: 'Banyan Log', kind: 'block', color: '#69462d', icon: 'BL', stack: 64, placeBlockId: 79 },
  '80': { id: '80', name: 'Nanmu Log', kind: 'block', color: '#806247', icon: 'NL', stack: 64, placeBlockId: 80 },
  '81': { id: '81', name: 'Birch Log', kind: 'block', color: '#d2c7ad', icon: 'BiL', stack: 64, placeBlockId: 81 },
  '82': { id: '82', name: 'Cypress Log', kind: 'block', color: '#75442f', icon: 'CyL', stack: 64, placeBlockId: 82 },
  '83': { id: '83', name: 'Maple Log', kind: 'block', color: '#8e5a3a', icon: 'ML', stack: 64, placeBlockId: 83 },
  '84': { id: '84', name: 'Conifer Log', kind: 'block', color: '#5f4a35', icon: 'CoL', stack: 64, placeBlockId: 84 },
  '85': { id: '85', name: 'Juniper Log', kind: 'block', color: '#7a7564', icon: 'JL', stack: 64, placeBlockId: 85 },
  '86': { id: '86', name: 'Fir Log', kind: 'block', color: '#5a4836', icon: 'FL', stack: 64, placeBlockId: 86 },
  '87': { id: '87', name: 'Camphor Planks', kind: 'block', color: '#c8a77f', icon: 'CP', stack: 64, placeBlockId: 87 },
  '88': { id: '88', name: 'Banyan Planks', kind: 'block', color: '#bd9368', icon: 'BP', stack: 64, placeBlockId: 88 },
  '89': { id: '89', name: 'Nanmu Planks', kind: 'block', color: '#d2b188', icon: 'NP', stack: 64, placeBlockId: 89 },
  '90': { id: '90', name: 'Birch Planks', kind: 'block', color: '#e6ddb9', icon: 'BiP', stack: 64, placeBlockId: 90 },
  '91': { id: '91', name: 'Cypress Planks', kind: 'block', color: '#ba8564', icon: 'CyP', stack: 64, placeBlockId: 91 },
  '92': { id: '92', name: 'Maple Planks', kind: 'block', color: '#d39a72', icon: 'MP', stack: 64, placeBlockId: 92 },
  '93': { id: '93', name: 'Conifer Planks', kind: 'block', color: '#b59277', icon: 'CoP', stack: 64, placeBlockId: 93 },
  '94': { id: '94', name: 'Juniper Planks', kind: 'block', color: '#c9c0ab', icon: 'JP', stack: 64, placeBlockId: 94 },
  '95': { id: '95', name: 'Fir Planks', kind: 'block', color: '#b89d83', icon: 'FP', stack: 64, placeBlockId: 95 },
  '8': { id: '8', name: 'Iron Ore', kind: 'block', color: '#9f8d7f', icon: 'Fe', stack: 64, placeBlockId: 8 },
  '10': { id: '10', name: 'Diamond Ore', kind: 'block', color: '#49c7da', icon: 'Dia', stack: 64, placeBlockId: 10 },
  '11': { id: '11', name: 'Crafting Table', kind: 'block', color: '#a0713f', icon: 'CT', stack: 16, placeBlockId: 11 },
  '13': { id: '13', name: 'Furnace', kind: 'block', color: '#727780', icon: 'F', stack: 16, placeBlockId: 13 },
  '14': { id: '14', name: 'Chest', kind: 'block', color: '#936233', icon: 'Ch', stack: 16, placeBlockId: 14 },
  '15': { id: '15', name: 'Bed', kind: 'block', color: '#a13f3f', icon: 'Bed', stack: 1, placeBlockId: 15 },
  '16': { id: '16', name: 'Oak Door', kind: 'block', color: '#9b6c3a', icon: 'Dr', stack: 64, placeBlockId: 16 },
  '18': { id: '18', name: 'Trapdoor', kind: 'block', color: '#8f6131', icon: 'Td', stack: 64, placeBlockId: 18 },
  '20': { id: '20', name: 'Fence', kind: 'block', color: '#936333', icon: 'Fe', stack: 64, placeBlockId: 20 },
  '21': { id: '21', name: 'Sandstone', kind: 'block', color: '#dcc18b', icon: 'Sa', stack: 64, placeBlockId: 21 },
  '22': { id: '22', name: 'Bricks', kind: 'block', color: '#b3604a', icon: 'Br', stack: 64, placeBlockId: 22 },
  '23': { id: '23', name: 'Glass', kind: 'block', color: '#b9e7f4', icon: 'Gl', stack: 64, placeBlockId: 23 },
  '24': { id: '24', name: 'White Concrete', kind: 'block', color: '#e6e6e3', icon: 'WC', stack: 64, placeBlockId: 24 },
  '25': { id: '25', name: 'Asphalt', kind: 'block', color: '#303236', icon: 'As', stack: 64, placeBlockId: 25 },
  '26': { id: '26', name: 'Sand', kind: 'block', color: '#d9ca8e', icon: 'Sd', stack: 64, placeBlockId: 26 },
  '27': { id: '27', name: 'Gravel', kind: 'block', color: '#8d8d93', icon: 'Gr', stack: 64, placeBlockId: 27 },
  '28': { id: '28', name: 'Cobblestone', kind: 'block', color: '#737377', icon: 'Cb', stack: 64, placeBlockId: 28 },
  '29': { id: '29', name: 'Stone Bricks', kind: 'block', color: '#8a8c90', icon: 'SB', stack: 64, placeBlockId: 29 },
  '30': { id: '30', name: 'Smooth Stone', kind: 'block', color: '#95979d', icon: 'Sm', stack: 64, placeBlockId: 30 },
  '31': { id: '31', name: 'Obsidian', kind: 'block', color: '#2a2440', icon: 'Ob', stack: 64, placeBlockId: 31 },
  '32': { id: '32', name: 'Mossy Cobblestone', kind: 'block', color: '#6d765f', icon: 'MC', stack: 64, placeBlockId: 32 },
  '33': { id: '33', name: 'Chiseled Stone Bricks', kind: 'block', color: '#84888d', icon: 'CS', stack: 64, placeBlockId: 33 },
  '34': { id: '34', name: 'Cracked Stone Bricks', kind: 'block', color: '#72767b', icon: 'Cr', stack: 64, placeBlockId: 34 },
  '35': { id: '35', name: 'Coal Block', kind: 'block', color: '#2e3035', icon: 'CBk', stack: 64, placeBlockId: 35 },
  '36': { id: '36', name: 'Iron Block', kind: 'block', color: '#c6c0b4', icon: 'IBl', stack: 64, placeBlockId: 36 },
  '37': { id: '37', name: 'Diamond Block', kind: 'block', color: '#64dff6', icon: 'DBl', stack: 64, placeBlockId: 37 },
  '38': { id: '38', name: 'Glowstone', kind: 'block', color: '#d2a15e', icon: 'Gw', stack: 64, placeBlockId: 38 },
  '39': { id: '39', name: 'Quartz Block', kind: 'block', color: '#f3eee7', icon: 'Qz', stack: 64, placeBlockId: 39 },
  '40': { id: '40', name: 'Netherrack', kind: 'block', color: '#7a2e26', icon: 'Nr', stack: 64, placeBlockId: 40 },
  '41': { id: '41', name: 'Soul Sand', kind: 'block', color: '#5b463a', icon: 'Ss', stack: 64, placeBlockId: 41 },
  '42': { id: '42', name: 'Nether Bricks', kind: 'block', color: '#381f23', icon: 'Nb', stack: 64, placeBlockId: 42 },
  '44': { id: '44', name: 'End Stone', kind: 'block', color: '#d7d3a6', icon: 'Es', stack: 64, placeBlockId: 44 },
  '45': { id: '45', name: 'Purpur Block', kind: 'block', color: '#9b7aa4', icon: 'Pu', stack: 64, placeBlockId: 45 },
  '47': { id: '47', name: 'Gold Ore', kind: 'block', color: '#b59d53', icon: 'AuO', stack: 64, placeBlockId: 47 },
  '48': { id: '48', name: 'Gold Block', kind: 'block', color: '#e2bf4a', icon: 'AuB', stack: 64, placeBlockId: 48 },
  '58': { id: '58', name: 'Lever', kind: 'block', color: '#7f7f7f', icon: 'Lev', stack: 64, placeBlockId: 58 },
  '60': { id: '60', name: 'Redstone Wire', kind: 'block', color: '#a83232', icon: 'Rs', stack: 64, placeBlockId: 60 },
  '62': { id: '62', name: 'Redstone Lamp', kind: 'block', color: '#6a4f2c', icon: 'RL', stack: 64, placeBlockId: 62 },
  '65': { id: '65', name: 'Oak Sapling', kind: 'block', color: '#54ad48', icon: 'Sp', stack: 64, placeBlockId: 65 },
  '68': { id: '68', name: 'Hay Bale', kind: 'block', color: '#d2b75f', icon: 'Hay', stack: 64, placeBlockId: 68 },
  '70': { id: '70', name: 'Snow Block', kind: 'block', color: '#f2f8fc', icon: 'Sn', stack: 64, placeBlockId: 70 },
  '71': { id: '71', name: 'Ice', kind: 'block', color: '#8cbfe6', icon: 'Ic', stack: 64, placeBlockId: 71 },
  '72': { id: '72', name: 'Cactus', kind: 'block', color: '#136b19', icon: 'Ca', stack: 64, placeBlockId: 72 },
  '73': { id: '73', name: 'Kelp', kind: 'block', color: '#2a7c30', icon: 'Ke', stack: 64, placeBlockId: 73 },
  '74': { id: '74', name: 'Basalt', kind: 'block', color: '#4d5159', icon: 'Bs', stack: 64, placeBlockId: 74 },
  '75': { id: '75', name: 'Volcanic Rock', kind: 'block', color: '#2b2a2a', icon: 'VR', stack: 64, placeBlockId: 75 },
  '77': { id: '77', name: 'Red Brick', kind: 'block', color: '#9f473a', icon: 'RB', stack: 64, placeBlockId: 77 },

  coal: { id: 'coal', name: 'Coal', kind: 'material', color: '#3f3f45', icon: 'C', stack: 64 },
  charcoal: { id: 'charcoal', name: 'Charcoal', kind: 'material', color: '#55575f', icon: 'Ch', stack: 64 },
  bone: { id: 'bone', name: 'Bone', kind: 'material', color: '#e9e6db', icon: 'Bo', stack: 64 },
  bone_meal: { id: 'bone_meal', name: 'Bone Meal', kind: 'material', color: '#f2eee4', icon: 'BM', stack: 64 },
  gunpowder: { id: 'gunpowder', name: 'Gunpowder', kind: 'material', color: '#596a54', icon: 'Gp', stack: 64 },
  feather: { id: 'feather', name: 'Feather', kind: 'material', color: '#f2eee7', icon: 'Fea', stack: 64 },
  flint: { id: 'flint', name: 'Flint', kind: 'material', color: '#4f555e', icon: 'Fl', stack: 64 },
  leather: { id: 'leather', name: 'Leather', kind: 'material', color: '#9a6f44', icon: 'Le', stack: 64 },
  wool: { id: 'wool', name: 'Wool', kind: 'material', color: '#e9e5df', icon: 'Wo', stack: 64 },
  stick: { id: 'stick', name: 'Stick', kind: 'material', color: '#b78f65', icon: '|', stack: 64 },
  string: { id: 'string', name: 'String', kind: 'material', color: '#d8d8d1', icon: 'St', stack: 64 },
  arrow: { id: 'arrow', name: 'Arrow', kind: 'material', color: '#c8bfaf', icon: 'Ar', stack: 64 },
  ender_eye: { id: 'ender_eye', name: 'Eye of Ender', kind: 'material', color: '#7e63cb', icon: 'Eye', stack: 64 },
  iron_ingot: { id: 'iron_ingot', name: 'Iron Ingot', kind: 'material', color: '#c9b7a0', icon: 'Fe', stack: 64 },
  gold_ingot: { id: 'gold_ingot', name: 'Gold Ingot', kind: 'material', color: '#e2bf4a', icon: 'Au', stack: 64 },
  diamond_gem: { id: 'diamond_gem', name: 'Diamond', kind: 'material', color: '#59d7ff', icon: 'D', stack: 64 },
  emerald: { id: 'emerald', name: 'Emerald', kind: 'material', color: '#3ac36a', icon: 'Em', stack: 64 },
  wheat_seed: { id: 'wheat_seed', name: 'Wheat Seeds', kind: 'material', color: '#bda85b', icon: 'Se', stack: 64 },
  wheat: { id: 'wheat', name: 'Wheat', kind: 'material', color: '#d5be62', icon: 'Wh', stack: 64 },
  torch: { id: 'torch', name: 'Torch', kind: 'block', color: '#f1b955', icon: 'T', stack: 64, placeBlockId: 12, light: { color: 0xffd392, intensity: 2.8, distance: 26, decay: 1.2 } },

  beef_raw: { id: 'beef_raw', name: 'Raw Beef', kind: 'food', color: '#9f3b34', icon: 'B', stack: 64, nutrition: 3, heal: 0 },
  mutton_raw: { id: 'mutton_raw', name: 'Raw Mutton', kind: 'food', color: '#a76452', icon: 'M', stack: 64, nutrition: 3, heal: 0 },
  pork_raw: { id: 'pork_raw', name: 'Raw Pork', kind: 'food', color: '#b56d7a', icon: 'P', stack: 64, nutrition: 3, heal: 0 },
  chicken_raw: { id: 'chicken_raw', name: 'Raw Chicken', kind: 'food', color: '#d7b69b', icon: 'C', stack: 64, nutrition: 2, heal: 0 },
  rotten_flesh: { id: 'rotten_flesh', name: 'Rotten Flesh', kind: 'food', color: '#8d6f53', icon: 'RF', stack: 64, nutrition: 4, heal: 0 },
  spider_eye: { id: 'spider_eye', name: 'Spider Eye', kind: 'food', color: '#7f2525', icon: 'SE', stack: 64, nutrition: 2, heal: 0 },
  beef_cooked: { id: 'beef_cooked', name: 'Steak', kind: 'food', color: '#8c4c36', icon: 'SB', stack: 64, nutrition: 8, heal: 0 },
  mutton_cooked: { id: 'mutton_cooked', name: 'Cooked Mutton', kind: 'food', color: '#a56f4f', icon: 'CM', stack: 64, nutrition: 6, heal: 0 },
  pork_cooked: { id: 'pork_cooked', name: 'Cooked Porkchop', kind: 'food', color: '#b46b62', icon: 'CP', stack: 64, nutrition: 8, heal: 0 },
  chicken_cooked: { id: 'chicken_cooked', name: 'Cooked Chicken', kind: 'food', color: '#c89a68', icon: 'CC', stack: 64, nutrition: 6, heal: 0 },
  bread: { id: 'bread', name: 'Bread', kind: 'food', color: '#c9924d', icon: 'Brd', stack: 64, nutrition: 5, heal: 0 },
  apple: { id: 'apple', name: 'Apple', kind: 'food', color: '#cf3f37', icon: 'Ap', stack: 64, nutrition: 4, heal: 0 },
  berry: { id: 'berry', name: 'Berry', kind: 'food', color: '#bc2d4f', icon: 'Be', stack: 64, nutrition: 2, heal: 0 },
  blueberry: { id: 'blueberry', name: 'Blueberry', kind: 'food', color: '#4a5ec2', icon: 'Bb', stack: 64, nutrition: 3, heal: 0 },
  aloe: { id: 'aloe', name: 'Aloe', kind: 'food', color: '#59b86e', icon: 'Al', stack: 64, nutrition: 0, heal: 2, isMedicine: true },
  painkiller: { id: 'painkiller', name: 'Painkiller', kind: 'food', color: '#66b5d9', icon: 'Pk', stack: 16, nutrition: 0, heal: 4, isMedicine: true },
  medkit: { id: 'medkit', name: 'Med Kit', kind: 'food', color: '#e26f6f', icon: 'Mk', stack: 8, nutrition: 0, heal: 8, isMedicine: true },

  wood_pickaxe: {
    id: 'wood_pickaxe',
    name: 'Wood Pickaxe',
    kind: 'tool',
    color: '#a77a4f',
    icon: 'WP',
    stack: 1,
    toolType: 'pickaxe',
    tier: 'wood',
    maxDurability: 60,
    attackDamage: 2.0
  },
  stone_pickaxe: {
    id: 'stone_pickaxe',
    name: 'Stone Pickaxe',
    kind: 'tool',
    color: '#8a8a8a',
    icon: 'SP',
    stack: 1,
    toolType: 'pickaxe',
    tier: 'stone',
    maxDurability: 132,
    attackDamage: 3.0
  },
  iron_pickaxe: {
    id: 'iron_pickaxe',
    name: 'Iron Pickaxe',
    kind: 'tool',
    color: '#c2b6a2',
    icon: 'IP',
    stack: 1,
    toolType: 'pickaxe',
    tier: 'iron',
    maxDurability: 251,
    attackDamage: 4.0
  },
  diamond_pickaxe: {
    id: 'diamond_pickaxe',
    name: 'Diamond Pickaxe',
    kind: 'tool',
    color: '#5bd6ea',
    icon: 'DP',
    stack: 1,
    toolType: 'pickaxe',
    tier: 'diamond',
    maxDurability: 1561,
    attackDamage: 5.0
  },

  wood_axe: {
    id: 'wood_axe',
    name: 'Wood Axe',
    kind: 'tool',
    color: '#a77a4f',
    icon: 'WA',
    stack: 1,
    toolType: 'axe',
    tier: 'wood',
    maxDurability: 60,
    attackDamage: 3.0
  },
  stone_axe: {
    id: 'stone_axe',
    name: 'Stone Axe',
    kind: 'tool',
    color: '#8a8a8a',
    icon: 'SA',
    stack: 1,
    toolType: 'axe',
    tier: 'stone',
    maxDurability: 132,
    attackDamage: 4.0
  },
  iron_axe: {
    id: 'iron_axe',
    name: 'Iron Axe',
    kind: 'tool',
    color: '#c2b6a2',
    icon: 'IA',
    stack: 1,
    toolType: 'axe',
    tier: 'iron',
    maxDurability: 251,
    attackDamage: 5.0
  },
  diamond_axe: {
    id: 'diamond_axe',
    name: 'Diamond Axe',
    kind: 'tool',
    color: '#5bd6ea',
    icon: 'DA',
    stack: 1,
    toolType: 'axe',
    tier: 'diamond',
    maxDurability: 1561,
    attackDamage: 6.0
  },

  wood_shovel: {
    id: 'wood_shovel',
    name: 'Wood Shovel',
    kind: 'tool',
    color: '#a77a4f',
    icon: 'WS',
    stack: 1,
    toolType: 'shovel',
    tier: 'wood',
    maxDurability: 60,
    attackDamage: 1.5
  },
  stone_shovel: {
    id: 'stone_shovel',
    name: 'Stone Shovel',
    kind: 'tool',
    color: '#8a8a8a',
    icon: 'SS',
    stack: 1,
    toolType: 'shovel',
    tier: 'stone',
    maxDurability: 132,
    attackDamage: 2.0
  },
  iron_shovel: {
    id: 'iron_shovel',
    name: 'Iron Shovel',
    kind: 'tool',
    color: '#c2b6a2',
    icon: 'IS',
    stack: 1,
    toolType: 'shovel',
    tier: 'iron',
    maxDurability: 251,
    attackDamage: 2.5
  },
  diamond_shovel: {
    id: 'diamond_shovel',
    name: 'Diamond Shovel',
    kind: 'tool',
    color: '#5bd6ea',
    icon: 'DS',
    stack: 1,
    toolType: 'shovel',
    tier: 'diamond',
    maxDurability: 1561,
    attackDamage: 3.0
  },
  wood_hoe: {
    id: 'wood_hoe',
    name: 'Wood Hoe',
    kind: 'tool',
    color: '#a77a4f',
    icon: 'WH',
    stack: 1,
    toolType: 'hoe',
    tier: 'wood',
    maxDurability: 60,
    attackDamage: 1.0
  },
  stone_hoe: {
    id: 'stone_hoe',
    name: 'Stone Hoe',
    kind: 'tool',
    color: '#8a8a8a',
    icon: 'SH',
    stack: 1,
    toolType: 'hoe',
    tier: 'stone',
    maxDurability: 132,
    attackDamage: 1.0
  },
  iron_hoe: {
    id: 'iron_hoe',
    name: 'Iron Hoe',
    kind: 'tool',
    color: '#c2b6a2',
    icon: 'IHoe',
    stack: 1,
    toolType: 'hoe',
    tier: 'iron',
    maxDurability: 251,
    attackDamage: 1.0
  },
  diamond_hoe: {
    id: 'diamond_hoe',
    name: 'Diamond Hoe',
    kind: 'tool',
    color: '#5bd6ea',
    icon: 'DHoe',
    stack: 1,
    toolType: 'hoe',
    tier: 'diamond',
    maxDurability: 1561,
    attackDamage: 1.0
  },

  wood_sword: {
    id: 'wood_sword',
    name: 'Wood Sword',
    kind: 'tool',
    color: '#ad8457',
    icon: 'WSw',
    stack: 1,
    toolType: 'sword',
    tier: 'wood',
    maxDurability: 60,
    attackDamage: 4.0
  },
  stone_sword: {
    id: 'stone_sword',
    name: 'Stone Sword',
    kind: 'tool',
    color: '#8a8a8a',
    icon: 'SSw',
    stack: 1,
    toolType: 'sword',
    tier: 'stone',
    maxDurability: 132,
    attackDamage: 5.0
  },
  iron_sword: {
    id: 'iron_sword',
    name: 'Iron Sword',
    kind: 'tool',
    color: '#c4b7a3',
    icon: 'ISw',
    stack: 1,
    toolType: 'sword',
    tier: 'iron',
    maxDurability: 251,
    attackDamage: 6.0
  },
  diamond_sword: {
    id: 'diamond_sword',
    name: 'Diamond Sword',
    kind: 'tool',
    color: '#59d7ff',
    icon: 'DSw',
    stack: 1,
    toolType: 'sword',
    tier: 'diamond',
    maxDurability: 1561,
    attackDamage: 7.0
  },
  gold_pickaxe: {
    id: 'gold_pickaxe',
    name: 'Gold Pickaxe',
    kind: 'tool',
    color: '#e2bf4a',
    icon: 'GP',
    stack: 1,
    toolType: 'pickaxe',
    tier: 'gold',
    maxDurability: 420,
    attackDamage: 4.5
  },
  gold_axe: {
    id: 'gold_axe',
    name: 'Gold Axe',
    kind: 'tool',
    color: '#e2bf4a',
    icon: 'GA',
    stack: 1,
    toolType: 'axe',
    tier: 'gold',
    maxDurability: 420,
    attackDamage: 5.5
  },
  gold_shovel: {
    id: 'gold_shovel',
    name: 'Gold Shovel',
    kind: 'tool',
    color: '#e2bf4a',
    icon: 'GS',
    stack: 1,
    toolType: 'shovel',
    tier: 'gold',
    maxDurability: 420,
    attackDamage: 2.75
  },
  gold_hoe: {
    id: 'gold_hoe',
    name: 'Gold Hoe',
    kind: 'tool',
    color: '#e2bf4a',
    icon: 'GHoe',
    stack: 1,
    toolType: 'hoe',
    tier: 'gold',
    maxDurability: 420,
    attackDamage: 1.0
  },
  gold_sword: {
    id: 'gold_sword',
    name: 'Gold Sword',
    kind: 'tool',
    color: '#e2bf4a',
    icon: 'GSw',
    stack: 1,
    toolType: 'sword',
    tier: 'gold',
    maxDurability: 420,
    attackDamage: 6.5
  },
  bow: {
    id: 'bow',
    name: 'Bow',
    kind: 'tool',
    color: '#c9ac79',
    icon: 'Bow',
    stack: 1,
    toolType: 'bow',
    tier: 'wood',
    maxDurability: 384,
    attackDamage: 2.2,
    rangedDamage: 8.0
  },
  shield: {
    id: 'shield',
    name: 'Shield',
    kind: 'tool',
    color: '#b89360',
    icon: 'Shd',
    stack: 1,
    toolType: 'shield',
    tier: 'iron',
    maxDurability: 336,
    attackDamage: 2.0
  },
  flint_steel: {
    id: 'flint_steel',
    name: 'Flint and Steel',
    kind: 'tool',
    color: '#8f949e',
    icon: 'FS',
    stack: 1,
    toolType: 'flint_steel',
    tier: 'iron',
    maxDurability: 64,
    attackDamage: 2.0
  },
  shears: {
    id: 'shears',
    name: 'Shears',
    kind: 'tool',
    color: '#b8bdc7',
    icon: 'Sh',
    stack: 1,
    toolType: 'shears',
    tier: 'iron',
    maxDurability: 238,
    attackDamage: 1.0
  },
  bucket: {
    id: 'bucket',
    name: 'Bucket',
    kind: 'tool',
    color: '#bcc4d1',
    icon: 'Bk',
    stack: 1,
    toolType: 'bucket',
    tier: 'iron',
    attackDamage: 1.0
  },
  water_bucket: {
    id: 'water_bucket',
    name: 'Water Bucket',
    kind: 'tool',
    color: '#4a88dd',
    icon: 'WB',
    stack: 1,
    toolType: 'bucket',
    tier: 'iron',
    attackDamage: 1.0
  },
  lava_bucket: {
    id: 'lava_bucket',
    name: 'Lava Bucket',
    kind: 'tool',
    color: '#ff6a2a',
    icon: 'LB',
    stack: 1,
    toolType: 'bucket',
    tier: 'iron',
    attackDamage: 1.0
  },
  boat: {
    id: 'boat',
    name: 'Boat',
    kind: 'tool',
    color: '#9e7749',
    icon: 'Bt',
    stack: 1,
    toolType: 'watercraft',
    tier: 'wood',
    attackDamage: 1.0
  },
  bamboo_raft: {
    id: 'bamboo_raft',
    name: 'Bamboo Raft',
    kind: 'tool',
    color: '#d6b86f',
    icon: 'Rf',
    stack: 1,
    toolType: 'watercraft',
    tier: 'wood',
    attackDamage: 1.0
  },

  leather_helmet: {
    id: 'leather_helmet',
    name: 'Leather Cap',
    kind: 'armor',
    armorSlot: 'helmet',
    armor: 1,
    color: '#9a6f44',
    icon: 'LH',
    stack: 1,
    maxDurability: 55
  },
  leather_chestplate: {
    id: 'leather_chestplate',
    name: 'Leather Tunic',
    kind: 'armor',
    armorSlot: 'chestplate',
    armor: 3,
    color: '#90643e',
    icon: 'LC',
    stack: 1,
    maxDurability: 80
  },
  leather_leggings: {
    id: 'leather_leggings',
    name: 'Leather Pants',
    kind: 'armor',
    armorSlot: 'leggings',
    armor: 2,
    color: '#9a6f44',
    icon: 'LL',
    stack: 1,
    maxDurability: 75
  },
  leather_boots: {
    id: 'leather_boots',
    name: 'Leather Boots',
    kind: 'armor',
    armorSlot: 'boots',
    armor: 1,
    color: '#875d39',
    icon: 'LB',
    stack: 1,
    maxDurability: 65
  },

  iron_helmet: {
    id: 'iron_helmet',
    name: 'Iron Helmet',
    kind: 'armor',
    armorSlot: 'helmet',
    armor: 2,
    color: '#c2b6a2',
    icon: 'IH',
    stack: 1,
    maxDurability: 165
  },
  iron_chestplate: {
    id: 'iron_chestplate',
    name: 'Iron Chestplate',
    kind: 'armor',
    armorSlot: 'chestplate',
    armor: 6,
    color: '#b9ad99',
    icon: 'IC',
    stack: 1,
    maxDurability: 240
  },
  iron_leggings: {
    id: 'iron_leggings',
    name: 'Iron Leggings',
    kind: 'armor',
    armorSlot: 'leggings',
    armor: 5,
    color: '#c0b39f',
    icon: 'IL',
    stack: 1,
    maxDurability: 225
  },
  iron_boots: {
    id: 'iron_boots',
    name: 'Iron Boots',
    kind: 'armor',
    armorSlot: 'boots',
    armor: 2,
    color: '#b7ab97',
    icon: 'IB',
    stack: 1,
    maxDurability: 195
  },

  diamond_helmet: {
    id: 'diamond_helmet',
    name: 'Diamond Helmet',
    kind: 'armor',
    armorSlot: 'helmet',
    armor: 3,
    color: '#68d9f4',
    icon: 'DH',
    stack: 1,
    maxDurability: 363
  },
  diamond_chestplate: {
    id: 'diamond_chestplate',
    name: 'Diamond Chestplate',
    kind: 'armor',
    armorSlot: 'chestplate',
    armor: 8,
    color: '#5ed1eb',
    icon: 'DC',
    stack: 1,
    maxDurability: 528
  },
  diamond_leggings: {
    id: 'diamond_leggings',
    name: 'Diamond Leggings',
    kind: 'armor',
    armorSlot: 'leggings',
    armor: 6,
    color: '#62d4ee',
    icon: 'DL',
    stack: 1,
    maxDurability: 495
  },
  diamond_boots: {
    id: 'diamond_boots',
    name: 'Diamond Boots',
    kind: 'armor',
    armorSlot: 'boots',
    armor: 3,
    color: '#58cae4',
    icon: 'DB',
    stack: 1,
    maxDurability: 429
  },

  gold_helmet: {
    id: 'gold_helmet',
    name: 'Gold Helmet',
    kind: 'armor',
    armorSlot: 'helmet',
    armor: 2,
    color: '#e2bf4a',
    icon: 'GH',
    stack: 1,
    maxDurability: 77
  },
  gold_chestplate: {
    id: 'gold_chestplate',
    name: 'Gold Chestplate',
    kind: 'armor',
    armorSlot: 'chestplate',
    armor: 5,
    color: '#d9b447',
    icon: 'GC',
    stack: 1,
    maxDurability: 112
  },
  gold_leggings: {
    id: 'gold_leggings',
    name: 'Gold Leggings',
    kind: 'armor',
    armorSlot: 'leggings',
    armor: 3,
    color: '#ddb949',
    icon: 'GL',
    stack: 1,
    maxDurability: 105
  },
  gold_boots: {
    id: 'gold_boots',
    name: 'Gold Boots',
    kind: 'armor',
    armorSlot: 'boots',
    armor: 1,
    color: '#d6b140',
    icon: 'GB',
    stack: 1,
    maxDurability: 91
  }
};

export const HOTBAR_DEFAULT = ['3', '6', '5', '11', 'wood_pickaxe', 'wood_sword', 'shield', 'bow', 'beef_raw'];

export const TREE_LOG_BLOCK_IDS = Object.freeze([3, 78, 79, 80, 81, 82, 83, 84, 85, 86]);
export const TREE_PLANK_BLOCK_IDS = Object.freeze([6, 87, 88, 89, 90, 91, 92, 93, 94, 95]);
export const TREE_LOG_ITEM_IDS = Object.freeze(TREE_LOG_BLOCK_IDS.map((id) => String(id)));
export const TREE_PLANK_ITEM_IDS = Object.freeze(TREE_PLANK_BLOCK_IDS.map((id) => String(id)));
